// extracted by mini-css-extract-plugin
module.exports = {"modalCloseIcon":"styles_modalCloseIcon__28QJ2"};